export default {
  // 標籤頁
  otcTrading: "OTC交易",
  depositWithdrawTrading: "充提交易",
  userBehavior: "用戶行為",
  accountBalance: "賬戶餘額",
  walletBalance: "錢包餘額",
  loginDeviceInfo: "登錄/設備信息",
  deliveryInfo: "收貨信息",
  paymentMethodRecord: "收款方式記錄",

  // 消息提示
  alreadyCurrentPage: "已經是當前詳情頁!",
};
